import styled from "styled-components";

export const MessageContainer = styled.div`
  justify-content: center;
  display: flex;
  margin-top: 5px;
  font-weight: bold;
`;
